import { SharePointListClient, type ListItem } from '../SharePointListClient';

/**
 * `10.RetencionesPago` — retention rows per compra + (optionally) per
 * pago. When `IDPago_RP` is blank, the retention is "standalone" —
 * registered at compra save time, awaiting a future pago to link it.
 *
 * `ImporteRetenido_RP` is the retention amount applied to the compra's
 * balance. `ImporteISAR_RP` is the taxable base.
 *
 * No display/internal name quirks. Numeric fields stored as
 * comma-decimal text.
 */
export type RetencionPagoFields = {
  Title?: string | null;
  IDCompra_RP?: string | null;
  IDPago_RP?: string | null;
  Proveedor_RP?: string | null;
  Tipo_RP?: string | null;
  Concepto_RP?: string | null;
  Descripcion_RP?: string | null;
  NroComprobante_RP?: string | null;
  ImporteISAR_RP?: string | null;
  ImporteRetenido_RP?: string | null;
  FechaComprobante_RP?: string | null;
  ComprobanteAdjunto_RP?: string | null;
  Moneda_RP?: string | null;
  TipoCambio_RP?: string | null;
  ImporteUSD_RP?: string | null;
  Status_RP?: 'Activo' | 'Anulado' | string | null;
  /** Stage 4b-2 — DriveItem id + filename of the auto-generated certificate. */
  CertificadoDriveItemID_RP?: string | null;
  CertificadoFileName_RP?: string | null;
};

export type RetencionPagoItem = ListItem<RetencionPagoFields>;

export const retencionesPagoClient =
  new SharePointListClient<RetencionPagoFields>('RetencionesPago');
